// extracted by mini-css-extract-plugin
export default {"menu":"qcL434OZ6L4BUe_XvanQ","closeIcon":"KaMz1XKX7FuAss9DSd1s"};